import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'

import Form from '../elements/Form'
import TextInput from '../elements/forms/TextInput'
import ColorSelect from '../elements/forms/ColorSelect'
import Dismissible from '../elements/Dismissible'
import AppConstants from '../../utils/AppConstants'
import AppUtils from '../../utils/AppUtils'

const ERROR = {
  EMPTY_NAME: 'Le nom ne peut pas être vide.',
  EMPTY_COLOR: 'Veuillez sélectionner une couleur.'
}

class CategoryForm extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      input: this.getInitialInput(props),
      formErrors: []
    }

    // Bind events
    this.onChangeInputName = this.onChangeInputName.bind(this)
    this.onChangeInputColor = this.onChangeInputColor.bind(this)
    this.onSubmit = this.onSubmit.bind(this)

    // Register submit event
    if (_.isFunction(this.props.registerSubmit)) {
      this.props.registerSubmit(this.onSubmit)
    }
  }

  getInitialInput(props = this.props) {
    return {
      name: (props.data && props.data.name) || '',
      color: (props.data && props.data.color && props.data.color.id) || null
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // When async fetch finished
    if (prevProps.isLoading && !this.props.isLoading) {
      this.setState({
        input: this.getInitialInput()
      })
    }
  }

  onChangeInputName(name) {
    this.setState((prevState, props) => ({
      input: _.extend(
        {},
        prevState.input,
        {
          name
        }
      )
    }))
  }

  onChangeInputColor(color) {
    this.setState((prevState, props) => ({
      input: _.extend(
        {},
        prevState.input,
        {
          color
        }
      )
    }))
  }

  onSubmit() {
    // Check that fields have been filled
    const formErrors = []
    if (!_.isString(this.state.input.name) || this.state.input.name.length === 0) {
      formErrors.push(ERROR.EMPTY_NAME)
    }
    if (_.isNull(this.state.input.color)) {
      formErrors.push(ERROR.EMPTY_COLOR)
    }
    this.setState({
      formErrors
    })
    if (!_.isEmpty(formErrors)) {
      return;
    }

    // Build and submit correctly formatted input
    const input = _.extend(
      {},
      _.pick(this.state.input, 'name'),
      {
        color: {
          id: this.state.input.color
        }
      }
    )
    this.props.onSubmit(input)
  }

  render() {
    return (
      <React.Fragment>
        {
          this.props.error
            ? <Dismissible
                header={AppUtils.errorToTitle(this.props.error)}
                content={AppUtils.errorToText(this.props.error, {
                  [AppConstants.ERROR.BAD_REQUEST.UNICITY_CONSTRAINT_VIOLATION]: 'Une catégorie avec ce nom existe déjà.'
                })}
                color='red'
                onDismiss={this.props.onClearError}
              />
            : null
        }
        {
          !_.isEmpty(this.state.formErrors)
            ? <Dismissible
                content='Veuillez résoudre les problèmes ci-dessous avant de poursuivre.'
                color='orange'
              />
            : null
        }
        <Form
          onSubmit={this.onSubmit}
          loading={this.props.isLoading || this.props.isSaving}
        >
          <TextInput
            label='Nom'
            placeholder='Tuyaux'
            value={this.state.input.name}
            onChange={this.onChangeInputName}
            error={
              _.contains(this.state.formErrors, ERROR.EMPTY_NAME)
                ? ERROR.EMPTY_NAME
                : null
            }
          />
          <ColorSelect
            label='Couleur'
            loading={this.props.colorsIsFetching}
            options={this.props.colorsList}
            selected={this.state.input.color}
            onChange={this.onChangeInputColor}
            error={
              _.contains(this.state.formErrors, ERROR.EMPTY_COLOR)
                ? ERROR.EMPTY_COLOR
                : null
            }
          />
        </Form>
      </React.Fragment>
    )
  }
}

CategoryForm.propTypes = {
  data: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  onClearError: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool.isRequired,
  registerSubmit: PropTypes.func,
  error: PropTypes.object,
  colorsList: PropTypes.array,
  colorsIsFetching: PropTypes.bool.isRequired
}

export default CategoryForm



// WEBPACK FOOTER //
// ./src/components/forms/CategoryForm.js